<template>
  <div class="subs boards-group">
    <subscription-board-header-row @changenotification="changeNotification" :notificationProp="notifyAll" :emailAll="emailAll"
      @immediateChanged="immediateChanged" @dailyChanged="dailyChanged" @weeklyChanged="weeklyChanged" :isOpen="isOpen" @toggleOpen="toggleOpenHeader"/>
    <div v-if="profileBoardsCategories != null && emailSettings && showRows" :class="showContentClass">
      <subscription-board-category-group @refresh="refresh" @refreshEmail="refreshEmail"
        v-for="boardCat in profileBoardsCategories" :key="boardCat.boardCategoryName" :boardCategory="boardCat" :emailSettings="emailSettings"/> 

      <!-- <subscription-board-row v-for="board in profileBoards" :key="board.boardID" :board="board" :emailSetting="getEmailSettingForBoard(board.boardID)"/> -->
    </div>
  </div>
</template>

<script>
import SubscriptionBoardHeaderRow  from './SubscriptionBoardHeaderRow.vue';
import SubscriptionBoardRow from './SubscriptionBoardRow.vue';
import SubscriptionBoardCategoryGroup from "./SubscriptionBoardCategoryGroup.vue";
import api from '../../../api/api';

export default {
  props: ["boardCategories"],
  components: { SubscriptionBoardHeaderRow, SubscriptionBoardRow, SubscriptionBoardCategoryGroup },
  data() {
    return {
      profileBoardsCategories: [],
      emailSettings: [],
      showRows: true,
      isOpen: false,
      emailAll: false,
    }
  },
  created() {
    this.profileBoardsCategories = this.boardCategories;
    api.get('/Communication/boards').then(r => {
      this.emailSettings = r.data;
    });
  },
  watch: {
    boardCategories(newValue) {
      this.profileBoardsCategories = newValue;
    },
    emailSettings(val) {
      if(val && val.every(r=>r.immediate)){
        this.emailAll = true;
        this.$forceUpdate();
      }
    }
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
    refreshEmail() {
      api.get('/Communication/boards').then(r => {
        this.emailSettings = r.data;
        this.$forceUpdate();
      });
    },
    toggleOpenHeader() {
        this.isOpen = !this.isOpen;
    },
    changeNotification(e) {
      api.post('/Subscription/boards/bulk', {
        subscribeAll: e
      }).then(() => {
        this.$emit("refresh");
      });
    },
    getEmailSettingForBoard(boardId){
      return this.emailSettings.find(x => x.boardId == boardId);
    },
    immediateChanged(e) {
      api.post('/Communication/boards/bulk', {
        Immediate: e,
      }).then(() => {
        api.get('/Communication/boards').then(r => {
          this.emailSettings = r.data;
          this.$forceUpdate();
        });
      });
    },
    dailyChanged(e) {
      api.post('/Communication/boards/bulk', {
        Daily: e,
      }).then(() => {
        api.get('/Communication/boards').then(r => {
          this.showRows = false;
          this.emailSettings = null;
          this.emailSettings = r.data;
          this.$nextTick(() => {
            this.showRows = true;
          });
        });
      });
    },
    weeklyChanged(e) {
      api.post('/Communication/boards/bulk', {
        Weekly: e,
      }).then(() => {
        api.get('/Communication/boards').then(r => {
          this.showRows = false;
          this.emailSettings = null;
          this.emailSettings = r.data;
          this.$nextTick(() => {
            this.showRows = true;
          });
        });
      });
    },
  },
  computed: {
    notifyAll() {
      if(!this.profileBoardsCategories || this.profileBoardsCategories.length == 0){
        return false;
      }
      let profileBoards = [];
      for(let i = 0; i < this.profileBoardsCategories.length; i++){
          profileBoards.push(...this.profileBoardsCategories[i].boards);
      }
      return profileBoards.every(r=>r.subscribed);
    },
    showContentClass() {
        return {
            'subscription-board-rows': !this.isOpen,
            'subscription-board-rows-opened': this.isOpen
        }
    },
  }
}
</script>

<style>
    span.caret {
        cursor: pointer;
        user-select: none;
    }
    span.caret:before {
        content: "\25B6";
        color: var(--color-m);
        display: inline-block;
        margin-right: 6px;
        transform:rotate(0deg);
        transition-duration: 0.5s;
    }
    span.caret-down:before {
        transform: rotate(90deg);
        transition-duration: 0.5s;
    }
    .subscription-board-rows{
        overflow: hidden;
        transition: all 1s linear;
        height: 0px;
    }
    .subscription-board-rows-opened{
        overflow: hidden;
        transition: all 1s linear;
    }
</style>

